import { ICompanyProps, IHotelProps, IOfferProps } from "./cancellation";

export interface IDownpayment {
  downpaymentDueDate?: Date | null;
  downpaymentAmount?: number | null;
  downpaymentRemark?: string | null;
}

export const canChangeDownpayment = (hotel: IHotelProps, company: ICompanyProps, offer: IOfferProps) => {
  if (company.isPremium) return false;
  else return true;
};

export const canChangeOfferDownpayment = (offerStatus: string, versionStatus: string) => {
  if (offerStatus === 'PENDING') {
    if (versionStatus === 'WAITFORHOTELRESERVATION') return false;
    return true;
  }
  if (offerStatus === 'APPROVED') {
    if (versionStatus === 'APPROVED') return false;
    return true;
  }
  return false;
};

export const isDownpaymentValid = (downpayment: IDownpayment) => {
  if (downpayment.downpaymentAmount !== null && downpayment.downpaymentAmount !== undefined && downpayment.downpaymentDueDate) return true;
  return false;
};